import script from "./sf-input.vue?vue&type=script&setup=true&lang=ts&generic=MV"
export * from "./sf-input.vue?vue&type=script&setup=true&lang=ts&generic=MV"

import "./sf-input.vue?vue&type=style&index=0&id=42538ac7&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42538ac7"]])

export default __exports__